import { permissionAreaKeyNameOf } from "../../../helpers/permission.helpers";
import { ClaimsArea } from "../../../models/roles";
import { MenuMainNode } from "./nodes";

export function entityKeyResolver<T extends ClaimsArea>(name: Extract<keyof T, string>): string { return name; };

export const claimsMenu: MenuMainNode = {
  icon: 'claimsIconTemplate',
  title: 'Menu.Claims.Name',
  rootPath: '/claims',
  areaPermissionKey: permissionAreaKeyNameOf('claims'),
  children: [
    {
      title: 'Menu.Claims.ClaimsQueue.Name',
      abbreviation: 'Menu.Claims.ClaimsQueue.Abbreviation',
      link: '/claims/claims-queue',
      entityPermissionKey: entityKeyResolver('claimsQueue')
    },
    {
      title: 'Menu.Claims.ClaimsErrorQueue.Name',
      abbreviation: 'Menu.Claims.ClaimsErrorQueue.Abbreviation',
      link: '/claims/claims-error-queue',
      entityPermissionKey: entityKeyResolver('claimsErrorQueue')
    },
    {
      title: 'Menu.Claims.Claim.Name',
      abbreviation: 'Menu.Claims.Claim.Abbreviation',
      link: '/claims/claims',
      entityPermissionKey: entityKeyResolver('claims')
    },
    {
      title: 'Menu.Claims.InsuranceTransmittals.Name',
      abbreviation: 'Menu.Claims.InsuranceTransmittals.Abbreviation',
      link: '/claims/claim-batches',
      entityPermissionKey: entityKeyResolver('insuranceTransmittals')
    },
    {
      title: 'Menu.Claims.ClaimsExcel.Name',
      abbreviation: 'Menu.Claims.ClaimsExcel.Abbreviation',
      link: '/claims/claims-excel',
      entityPermissionKey: entityKeyResolver('claimsExcel')
    }
  ]
};
